import './index.scss'

jQuery(document).ready(function(){
function scroll_start(){
			

  var objStackingCards = jQuery("#scroll");
  var objStackingCardsWrapper = objStackingCards.find('.ue_cards_wrapper');
  var objCards = objStackingCards.find('.ue_stacking_card_item');
  var classActive = "active";
  var cardsStartPositions = getCardsStartPositions();
  var isClicked = false;

  //enable stiky position to calculate start position of all items
  enableStickyPos();

  
      
    var numCards = objCards.length; 

    // gsap.registerPlugin(ScrollTrigger);

    objCards.each(function(index0) {
        const card = jQuery(this);
        const index = index0 + 1;
        const reverseIndex0 = numCards - index;

        // Scroll Related Styles
        gsap.to(card[0], {
            duration: 2,
            scale: 1 - (-(-0.03) * reverseIndex0),            rotate: 0 * reverseIndex0,
             opacity: 1,                          filter:  `blur(${reverseIndex0 * 0}px) grayscale(${reverseIndex0 * 30}%)`,
                     
            scrollTrigger: {
                trigger: objStackingCardsWrapper[0],
                start: `${(index0 / numCards) * 100}% top`,  // Start at each card’s section
                end: "bottom center", // End at next wrapper section
                scrub: true,
                onToggle: (self) => {
                  objStackingCards.trigger("ue_stacking_card_change")
                },
                onEnter: function(){          
                },
                onLeaveBack: function(){
                }
            },
        });
    });
                                                                                            
  //end scroll_related_animation  
    
  /**
  * enable sticky position
  */
  function enableStickyPos(){
    if(!objCards || objCards.length == 0)
    return(false);
      
    objCards.css("position", "sticky");
  }   
                                                                                            
  /**
  * gety cards init positions
  */
  function getCardsStartPositions(){
    var cardsStartPositionsArray = [];
     
    if(!objCards || objCards.length == 0)
    return(null);
      
    objCards.each(function(){
      var objCard = jQuery(this);
      var cardOffset = objCard.offset().top;
        
      cardsStartPositionsArray.push(cardOffset);
    });
      
    return(cardsStartPositionsArray);
  }                                                                                        
       
  /**
  * get active index
  */
  function getActiveIndex(){
    var index;
    var objActiveCard = objStackingCards.find("."+classActive);
      
    if(!objActiveCard || objActiveCard.legnth == 0)
      return(null);
      
    index = objActiveCard.index();
    return(index);
  }
  
  /**
  * scroll
  */
  function scrollTo(changePosition, time){
    jQuery('html, body').animate({
        scrollTop: changePosition
    }, time)
  }                                                                                        
    
  //vars
                                                                                                                           
  //events                                                                                        
  objStackingCards.on("uc_change", function(e){
    var activeIndex = getActiveIndex();
	
    if(activeIndex == null)
      return(true);
    
    if(isClicked == true)
      return(true);
    
    isClicked = true;
    
    setTimeout(function(){
    	isClicked = false;
    },200);    
     
    var activeOffset = cardsStartPositions[activeIndex];
      
    //scroll to selected item
    scrollTo(activeOffset, 100);
  });
   
  function initFancyBox(){
        if("false" == "false")
        return(false);

        //init fancybox only on non cloned items
        var fancyLink = objStackingCards.find(".ue-link");

        fancyLink.attr("data-fancybox", "gallery")

        fancyLink.fancybox({
            loop: true,
            arrows : false,
            backfocus: false,         
            touch: false,
            buttons: [
              "close"
            ],          
        });
  } 
   
 initFancyBox();  
    
  var objRemoteOptions = {
    	class_items:"ue_stacking_card_item",
    	class_active:"ue-active",
    	selector_item_trigger:null,
        add_set_active_code:true
  };
      
  						objStackingCards.data("uc-remote-options", objRemoteOptions);
			
			objStackingCards.trigger("uc-object-ready");
			jQuery(document).trigger("uc-remote-parent-init", [objStackingCards]);
			 
             
}if(jQuery("#scroll").length) scroll_start();
	jQuery( document ).on( 'elementor/popup/show', (event, id, objPopup) => {
	if(objPopup.$element.has(jQuery("#scroll")).length) scroll_start();});
});


$(".section6 ul li").eq(0).addClass("active");
$(".section6 ul li .title").click(function() {
     let $dl = $(this).parent().parent();
    if($dl.hasClass("active")){
        $dl.removeClass("active");
    }else{
        $(".section6 ul li").removeClass("active");
        $dl.addClass("active");
    }
})

$(".section6 ul li .icon").click(function() {
     let $dl = $(this).parent();
    if($dl.hasClass("active")){
        $dl.removeClass("active");
    }else{
        $(".section6 ul li").removeClass("active");
        $dl.addClass("active");
    }
})